<template>
  <v-list dense class="pt-0 pb-0">
    <div :class="[isScroll && 'menu-scroll']">
      <v-list-group
        v-for="(children, i) in item.children"
        :key="i"
        :id="`menu-${children.id}`"
        :append-icon="'children' in children ? 'zmdi zmdi-chevron-down' : ''"
        @click="handler(children)"
        v-model="toggleDropdown[i]"
      >
        <template v-slot:activator>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon class="icon-shake mr-2" v-on="on">{{ children.icon }}</v-icon>
            </template>
            <span>{{ children.name }}</span>
          </v-tooltip>

          <v-list-item-title v-text="children.name"></v-list-item-title>
        </template>

        <v-list-item class="v-list-item--second" v-if="'children' in children">
          <v-list>
            <v-list-item-group>
              <v-list-item v-for="(subItem, i) in children.children" :key="i" :id="`menu-${subItem.id}`" @click="handler(subItem)">
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-icon class="icon-shake mr-2" v-on="on">{{ subItem.icon }}</v-icon>
                  </template>
                  <span>{{ subItem.name }}</span>
                </v-tooltip>

                <v-list-item-title v-text="subItem.name"></v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-list-item>
      </v-list-group>
    </div>
  </v-list>
</template>

<script>
import { handleLoadRoute } from '@/helpers/page';

export default {
  props: {
    item: { type: Object, default: () => ({}) },
    mini: { type: Boolean, default: false },
    menuModel: { type: Array, default: () => [] },
    isScroll: { type: Boolean, default: false }
  },

  data: () => ({
    toggleDropdown: {}
  }),

  methods: {
    handleLoadRoute,

    handler(param) {
      this.handleLoadRoute(param);

      if ('children' in param === false) {
        this.$emit('handleToggleDropdown');
      }
    },

    handleCloseDropdown() {
      for (var model in this.toggleDropdown) {
        this.toggleDropdown[model] = false;
      }
    }
  },

  watch: {
    mini(newValue) {
      if (newValue) {
        this.handleCloseDropdown();
      }
    },

    menuModel(newValue) {
      this.handleCloseDropdown();
    }
  }
};
</script>
